import modal from "react-modal";
import styled from "styled-components";

import { ButtonBar as SharedButtonBar } from "shared/ui/layout";

// 모달 컴포넌트
export const Modal = styled(modal)`
  display: flex;
  flex-direction: column;
  width: 620px;
  height: 552px;
  border-radius: 3px;
  background-color: #fff;
  margin: 15vh auto;
  padding: 40px 50px;
`;

// 모달 이름
export const ModalName = styled.h2`
  font-weight: bold;
`;

// 모달 레이아웃
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  margin: 40px 0;
`;

// 모달 행
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

// 입력 input
export const TextInput = styled.input`
  flex-grow: 1;
  height: 35px;
  border-radius: 2px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  /* margin-left: 5px; */
  padding: 2px 12px;
`;

// 버튼 리스트 레이아웃
export const ButtonBar = styled(SharedButtonBar)`
  gap: 30px;
  padding-bottom: 0;
`;

// 버튼 컴포넌트
export const ModalButton = styled.button`
  border-radius: 5px;
  padding: 8px 0px;
  min-width: 200px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  background-color: ${(props) =>
    props.disabled
      ? `var(--admin-gray-stroke, #e8e8e8)`
      : `var(--admin-blue-default-blue, #0079e0)`};
  cursor: ${(props) => (props.disabled ? `not-allowed` : `pointer`)};
`;
